import Vue from 'vue';
// eslint-disable-next-line import/no-cycle
import feathersClient from '../../feathers-client';
export default {
	state: {
		OnBoardedRecord: [],
	},
	getters: {
	},
	mutations: {
		SET_ON_BOARDED_USERS_RECORDS: (state, OnBoardedRecord) => { state.OnBoardedRecord = OnBoardedRecord; },

	},
	actions: {
		getOnBoardedUsersRecord({ commit }, userData) {
			commit('SET_ON_BOARDED_USERS_RECORDS', userData);
		  },
	},
};
